<template>
  <div class="py-2 mt-2">
    <template v-if="rule.description">
      <div
        class="d-flex align-items-center ps-2 py-3 mouse-hover description"
        @click="togleDisplay(rule.description.reference + ruleType.description)"
      >
        <div class="ps-1" />
        <RuleCaret
          v-model="displayDetails"
        />
        <div class="fw-bold ps-1 me-2">
          {{ trans('core.description') }}
        </div>
        <RuleSmallButton
          v-if="sameTranslation"
          :title="trans(`subscription.validation_rules.multi_language`)"
          type="button"
          class="focus-style btn-secondary my-2"
          @click.native.stop.prevent="enableMultiLanguage()"
        />
        <RuleSmallButton
          v-else
          :title="trans(`subscription.validation_rules.single_language`)"
          type="button"
          class="focus-style btn-secondary my-2"
          @click.native.stop.prevent="disableMultiLanguage()"
        />
        <div class="flex-grow-1" />
        <div
          class="fw-bold px-3 me-3 mouse-hover"
          @click="removeRuleProperty(ruleProperty.description)"
        >
          X
        </div>
      </div>
      <div
        v-if="displayDetails"
        class="mx-3 my-1"
      >
        <template v-if="sameTranslation">
          <RuleDescriptionTranslation
            :reference="rule.description.reference"
            :label="trans('core.description')"
            :text="rule.description.nl"
            :translation-type="'all'"
          />
        </template>
        <template v-else>
          <RuleDescriptionTranslation
            :reference="rule.description.reference"
            :label="trans('core.nl')"
            :text="rule.description.nl"
            :translation-type="'nl'"
          />
          <RuleDescriptionTranslation
            :reference="rule.description.reference"
            :label="trans('core.en')"
            :text="rule.description.en"
            :translation-type="'en'"
          />
        </template>
      </div>
    </template>
    <RuleDescriptionAdd
      v-else
      class="description"
      :rule-reference="reference"
    />
  </div>
</template>

<script>
import ruleMixin from '@/employees/components/Rule/utilities/mixins/ruleMixin'
import { RULE_PROPERTY, RULE_TYPE } from '@/constants'
import { mapState } from 'vuex'
export default {
  name: 'RuleDescription',
  mixins: [ruleMixin],
  props: {
    reference: {
      required: true,
      type: String,
    },
    rule: {
      /** @type {import('vue').PropType<import('./utilities/builder/ruleBuilder.js').Rule>} */
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      ruleProperty: RULE_PROPERTY,
      ruleType: RULE_TYPE,
      sameTranslation: false,
    }
  },
  computed: {
    ...mapState({
      displayDetails (state) {
        if (this.rule.description) {
          return state.rules.displayRuleMap[this.rule.description.reference + this.ruleType.description]
        }
        return undefined
      },
    }),
  },
  mounted () {
    if (this.rule.description) {
      this.sameTranslation = this.rule.description.nl === this.rule.description.en
    }
  },
  methods: {
    removeRuleProperty (rulePropertyEnum) {
      this.rulePropertyValueDelete(this.reference, rulePropertyEnum)
    },
    enableMultiLanguage () {
      this.sameTranslation = false
    },
    disableMultiLanguage () {
      this.sameTranslation = true
      this.rulePropertyValueChange(this.rule.description.reference, `${this.ruleProperty.description}.all`, this.rule.description.nl)
    },
  },
}
</script>

<style lang="scss" scoped>
.description {
  background: rgba(0, 0, 0, 0.2);
}
.mouse-hover {
  cursor: pointer
}
</style>
